import React from 'react';
import {CssBaseline, ThemeProvider} from '@mui/material';
import theme from '../../theme/theme';
import ReviewScreen from './reels/ReviewScreen';
import {runtimeEnvironment} from '../../lib/runtimeEnvironment';
import {contentReviewService, ContentReviewItem} from '../../services/contentReviewService';
import queued from '../../services/__fixtures__/revision-child/queued.json';
import refused from '../../services/__fixtures__/revision-child/refused.json';
import rendered from '../../services/__fixtures__/revision-child/rendered.json';
import ready from '../../services/__fixtures__/revision-child/ready.json';

/** Local replay of FastAPI/service_role captures and real synthetic FFmpeg media. */
export default function RevisionChildHarness(){
 if(runtimeEnvironment.environment==='production')throw new Error('Local replay only');
 const outcome=new URLSearchParams(window.location.search).get('outcome')??'ready';
 const fixtures:Record<string,{items:unknown[]}>={queued,refused,rendered,ready};
 const items=(fixtures[outcome]??ready).items as unknown as ContentReviewItem[];
 const [selected,setSelected]=React.useState(items[0].id);
 contentReviewService.media=async(id)=>({url:id===ready.items[0].id?'/revision-before.mp4':'/revision-after.mp4',expires_in_seconds:3600,sha256:'a'.repeat(64),bytes:1});
 return <ThemeProvider theme={theme}><CssBaseline/><ReviewScreen open items={items} relatedItems={items}
 index={Math.max(0,items.findIndex(item=>item.id===selected))} onOpenRelated={item=>setSelected(item.id)}
 onMove={index=>setSelected(items[index].id)} onClose={()=>{}} onVerdict={()=>{}}/></ThemeProvider>;
}
